import Axios from 'axios';
import React, { useContext, useEffect, useReducer, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import LoadingBox from '../component/LoadingBox';
import MessageBox from '../component/MessageBox';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { Store } from '../Store';
import { getError } from '../utils';
import { InvoicePageDouble, renderInvoicePdf } from './InvoiceTemplate';
import '../assets/invoice-classic.css';
import { api } from '../Api';

function reducer(state, action) {
  switch (action.type) {
    case 'FETCH_REQUEST':
      return { ...state, loading: true, error: '' };
    case 'FETCH_SUCCESS':
      return { ...state, loading: false, order: action.payload, error: '' };
    case 'FETCH_FAIL':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}

export default function InvoicePDF() {
  const { state } = useContext(Store);
  const { userInfo } = state;
  const { id: orderId } = useParams();
  const navigate = useNavigate();

  const [{ loading, error, order }, dispatch] = useReducer(reducer, {
    loading: true,
    order: {},
    error: '',
  });
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    if (!userInfo) {
      toast.error('Please Login');
      navigate('/signin');
      return;
    }
    const fetchOrder = async () => {
      try {
        dispatch({ type: 'FETCH_REQUEST' });
        const { data } = await Axios.get(`${api}/api/orders/${orderId}`, {
          headers: { authorization: `Bearer ${userInfo.token}` },
        });
        dispatch({ type: 'FETCH_SUCCESS', payload: data });
      } catch (err) {
        dispatch({ type: 'FETCH_FAIL', payload: getError(err) });
      }
    };
    fetchOrder();
  }, [orderId, userInfo, navigate]);

  async function downloadPdf() {
    const node = document.getElementById('invc-page');
    if (!node) {
      toast.error('Invoice not ready.');
      return;
    }
    setDownloading(true);
    try {
      await renderInvoicePdf(node, `Invoice_${order._id}.pdf`);
      toast.success('Invoice downloaded.');
    } catch (err) {
      toast.info('Opening print dialog — choose "Save as PDF".');
      window.print();
    } finally {
      setDownloading(false);
    }
  }

  function printInvoice() {
    window.print();
  }

  if (loading) return <LoadingBox />;
  if (error) return <MessageBox variant="danger">{error}</MessageBox>;
  if (!order || !order._id)
    return <MessageBox variant="warning">Order not found</MessageBox>;

  return (
    <div className="invc-wrap">
      <Helmet>
        <title>Invoice #{order._id.slice(-6).toUpperCase()}</title>
      </Helmet>
      <div className="invc-actions d-print-none">
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={() => window.history.back()}
        >
          ← Back
        </Button>
        <Button
          variant="primary"
          size="sm"
          onClick={printInvoice}
          disabled={downloading}
        >
          Print
        </Button>
        <Button
          variant="success"
          size="sm"
          onClick={downloadPdf}
          disabled={downloading}
        >
          {downloading ? (
            <>
              <Spinner animation="border" size="sm" /> Preparing…
            </>
          ) : (
            'Download PDF'
          )}
        </Button>
      </div>
      <InvoicePageDouble order={order} />
    </div>
  );
}
